import * as sentry from '../../src/utils/sentry'
import { IDB_unsyncedConfirmedActions } from '../IDB/IDB.dexie'
import type { ConfirmActionEndpoint } from '../../../server/client/client.no-deps'
import { Serv_client } from '../Serv/Serv.client'

/**
 * DEPRECATED after version 2.0.20
 * Only here to sync old actions up after migration. New ones will be in flowActionReports
 */

export const Sync_syncConfirmedActions = async () => {
    const unsyncedConfirmedActions = await IDB_unsyncedConfirmedActions().toArray()

    for (const unsyncedConfirmedAction of unsyncedConfirmedActions) {
        const actionToConfirm: ConfirmActionEndpoint['Body'] = {
            startDate: new Date(unsyncedConfirmedAction.startDate.value),
            coordinates: unsyncedConfirmedAction.coordinates,
            endDate: new Date(unsyncedConfirmedAction.startDate.value),
            clientId: unsyncedConfirmedAction.clientId,
            scheduledInstance: unsyncedConfirmedAction.scheduledInstance,
        }

        try {
            await Serv_client.confirmAction(actionToConfirm)
        } catch (error) {
            sentry.err(error, {})
            continue
        }

        await IDB_unsyncedConfirmedActions().delete(unsyncedConfirmedAction.clientId)
    }
}
